import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyRefund } from '../refundProxy'
import { FormFieldNamesEnum } from '../formFieldNamesEnum'
import { handleBlur, handleChange } from '../utils'
import { usdFormatter } from '../../../../../../../shared/utils/formattingUtils'
import { SubmitButton } from '../../../../../../../shared/components/ui/buttons/SubmitButton'
import { InputFieldType } from '../../../../../../../shared/types/InputFieldType'
import { StandardInput } from '../../../../../../../shared/components/ui/forms/StandardInput'
import UnderlineLabelSection from '../../../../../../../shared/components/ui/headings/UnderlineLabelSection'
import { executeRefundCreate } from './executeRefundCreate'

export function RefundForm (): ReactElement {
  const { allowSubmit, apiCallRefundCreate: { loading }, formErrors, formValues, showRefundAmountError, showEmailError, transaction } = useSnapshot(proxyRefund)
  return (
    <div className="bg-white shadow rounded p-6 w-1/3 m-auto">
      <form onSubmit={executeRefundCreate} className="flex flex-col justify-center items-center space-y-4">
        <div className="w-full">
          <UnderlineLabelSection labelText={`Max Refund -- ${usdFormatter.format(transaction?.remainingAmountCents ?? 0)}`} />
        </div>

        <div className="w-full">

          <StandardInput
            inputType={InputFieldType.Text}
            label="Refund Amount"
            preLabel="$"
            value={formValues.refundAmount || ''}
            onChange={handleChange(FormFieldNamesEnum.RefundAmount)}
            onBlur={handleBlur(FormFieldNamesEnum.RefundAmount)}
            showError={showRefundAmountError}
            errorMessage={formErrors.refundAmount || ''}
          />

        </div>

        <div className="w-full">
          <StandardInput
            inputType={InputFieldType.Text}
            label="Email"
            value={formValues.email || ''}
            onChange={handleChange(FormFieldNamesEnum.Email)}
            onBlur={handleBlur(FormFieldNamesEnum.Email)}
            showError={showEmailError}
            errorMessage={formErrors.email || ''}
          />
        </div>

        <div className="w-1/2">
          <SubmitButton widthFull text="Submit" disabled={!allowSubmit} anyLoading={loading} />
        </div>
      </form>
    </div>
  )
}
